
export enum PortsmouthRecordType  {           
        Monument = "mon",     
        Event = "event",
        Designation = "desig",
        AreaBoundary = "bound"
}  

export enum PortsmouthRecordSubType  {   
    ScheduledMonument = "SAM",
    RegisteredParksAndGardens = "RG",
    ListedBuilding = "LB"
}  

